import {
  CiselnikPolozka,
  SprievodnyDokumentMergedItem as SprievodnyDokumentMergedItemGenerated,
  SprievodnyDokumentMergedListApi,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../../configuration/apiConfigurationConstants';
import PolozkaCiselnik from '../../../model/ciselniky/PolozkaCiselnik';
import Uuid from '../../../model/Uuid';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import SprievodnyDokumentMergedItem from '../../../model/pracovnyKrok/SprievodnyDokumentMergedItem';

const client = new SprievodnyDokumentMergedListApi(apiConfiguration(elegislativaPrefixPath));

const mapTyp = (data: CiselnikPolozka): PolozkaCiselnik => ({
  uuid: data.uuid,
  nazov: data.nazov,
  platny: data.platny,
  existujeFormular: data.existujeFormular,
  povolitZadavanieFormularom: data.povolitZadavanieFormularom,
  generovanySystemom: data.generovanySystemom,
  kod: data.kod,
});

function map(sprievodnyDokumentMergedList: SprievodnyDokumentMergedItemGenerated[]): SprievodnyDokumentMergedItem[] {
  return sprievodnyDokumentMergedList.map(dokument => ({
    sprievodnyDokumentUuid: dokument.sprievodnyDokumentUuid,
    sablonaUuid: dokument.sablonaUuid,
    povinny: dokument.povinny,
    typDokumentu: mapTyp(dokument.typDokumentu),
    nazov: dokument.nazov,
    velkost: dokument.velkost,
    datumUlozenia: dokument.datumVytvorenia,
    formData: dokument.formData,
  }));
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSprievodnyDokumentMergedSablonaList = async (
  legMaterialUuid: Uuid,
  typMaterialuUuid: Uuid,
  stadiumUuid: Uuid,
  stadiumMaterialu: StadiumMaterialuEnum,
  headers?: object,
):
  Promise<ClientResponse<SprievodnyDokumentMergedItem[]>> => {
  const {
    data,
    status,
  } = await client.getSprievodnyDokumentListMergedSablonaList(
    legMaterialUuid,
    typMaterialuUuid,
    stadiumUuid,
    stadiumMaterialu,
    headers,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
